// @flow

export {default as createOutputInterceptor} from './createOutputInterceptor';
